import { DonateModal } from 'components/Modal/DonateModal';
import { ErrorBoundary } from 'react-error-boundary';
import { PausedModal } from 'components/Modal/PausedModal';
import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { MainContainer } from 'screens/Main/styled';
import Error from 'components/Error';
import { DesktopLeftContainer } from 'components/DesktopLeftContainer';
import { Body, H3 } from 'components/Typography';

interface Props {
  error?: string;
  leftSideSetRefWidthValue: (width: number) => void;
  pausedMisc?: any;
  showLeftSide: boolean;
  showPausedModal: boolean;
  showDonateModal: boolean;
}

const DonateAndCheckoutLayout: FC<Props> = ({
  error,
  leftSideSetRefWidthValue,
  pausedMisc,
  showLeftSide,
  showPausedModal,
  showDonateModal,
}) => {
  if (error) {
    return (
      <MainContainer>
        <Error
          data={{ component: 'Main' }}
          errorMsg="API failure on donate page"
          shouldAlert={!!error}
        >
          <H3>{error}</H3>
        </Error>
      </MainContainer>
    );
  }

  return (
    <MainContainer>
      {showPausedModal && <PausedModal paused_misc={pausedMisc} />}
      {showDonateModal && <DonateModal />}
      {showLeftSide && <DesktopLeftContainer setRefWidthValue={leftSideSetRefWidthValue} />}
      <ErrorBoundary
        fallback={
          <Error
            data={{ component: 'Slate' }}
            errorMsg="Failure with donate Slate component"
            shouldAlert={true}
          >
            <Body>We encountered an error. Please contact support.</Body>
          </Error>
        }
      >
        <Outlet />
      </ErrorBoundary>
    </MainContainer>
  );
};

export default DonateAndCheckoutLayout;
